import { render } from "./OtpView.vue?vue&type=template&id=6e3a753e&scoped=true"
import script from "./OtpView.vue?vue&type=script&lang=js"
export * from "./OtpView.vue?vue&type=script&lang=js"

import "./OtpView.vue?vue&type=style&index=0&id=6e3a753e&lang=css"
import "./OtpView.vue?vue&type=style&index=1&id=6e3a753e&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e3a753e"]])

export default __exports__